/**
 * Admin Dark Theme — Component Tokens
 *
 * Glass treatment over the gradient background. Preserves the current
 * admin look feel by expressing dark surfaces as semi-transparent panels.
 */
import type { AdminComponentTheme } from '@/constants/shared/theme/types';
import { PRIMITIVE_COLORS } from '@/constants/residents/residentColors';

export const adminDarkComponents: AdminComponentTheme = {
  sidebar: {
    bg: '#0c0c10',
    border: 'rgba(255,255,255,0.10)',
    itemActiveBg: 'rgba(70,114,254,0.10)',
    itemHoverBg: 'rgba(255,255,255,0.04)',
    label: '#EEF1F4',
    description: '#919191',
    indicator: PRIMITIVE_COLORS.resioBlue,
    headerGlow: [
      { color: 'rgba(71,115,254,0.22)', offset: 0 },
      { color: 'rgba(91,57,172,0.14)', offset: 0.4 },
      { color: 'rgba(171,52,112,0.08)', offset: 0.75 },
      { color: 'rgba(12,12,16,0)', offset: 1 },
    ],
    headerGlowHeight: 180,
  },
  header: {
    bg: 'transparent',
    border: 'rgba(255,255,255,0.06)',
    menuText: '#EEF1F4',
  },
  dataTable: {
    bg: 'rgba(14,14,14,0.78)',
    headerBg: 'rgba(0,0,0,0.45)',
    border: 'rgba(255,255,255,0.08)',
    row: 'transparent',
    rowAlt: 'rgba(255,255,255,0.02)',
    text: '#EEF1F4',
    filterBg: 'rgba(255,255,255,0.04)',
  },
  dataTableDensity: {
    compact: { cellPaddingY: 8, headerPaddingY: 10 },
    comfortable: { cellPaddingY: 14, headerPaddingY: 16 },
  },
  formInput: {
    bg: 'rgba(255,255,255,0.04)',
    border: 'rgba(255,255,255,0.10)',
    borderFocused: PRIMITIVE_COLORS.resioBlue,
    placeholder: '#777',
    text: '#EEF1F4',
    label: '#ACACAC',
  },
  selector: {
    bg: 'rgba(14,14,14,0.88)',
    border: 'rgba(255,255,255,0.10)',
    dropdownBg: '#0E0E0E',
    itemSelectedBg: 'rgba(70,114,254,0.12)',
    itemSelectedText: PRIMITIVE_COLORS.resioBlue,
  },
  dataCell: {
    text: '#EEF1F4',
    textMuted: '#919191',
    textAccent: PRIMITIVE_COLORS.resioBlue,
  },
};
